/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailShipping_viewer$ref: FragmentReference;
export type PdpSharedDetailShipping_viewer = {|
  +$fragmentRefs: PdpSharedShippingInfoLink_viewer$ref,
  +$refType: PdpSharedDetailShipping_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '08f31cbab893bfa6d0c33153be8b7872';
module.exports = node;
